import { AppBar, Tab, Tabs } from "@mui/material";
import { TabContext, TabPanel } from "@material-ui/lab";
import { Theme, createStyles, makeStyles } from "@material-ui/core/styles";

import DateTime from "../formatters/date-time";
import { Event } from "../../store/Event/EventModel";
// import HexEditor from "react-hex-editor";
import React from "react";
import ReactJson from "react-json-view";
import { Settings } from "../../store/Settings/SettingsModel";

const HexViewer: React.FunctionComponent<{ data: number[]; style?: React.CSSProperties }> = ({
  data,
  style,
}) => {
  const rows: string[] = [];
  for (let offset = 0; offset < data.length; offset += 16) {
    const bytes = data.slice(offset, offset + 16).map((byte) => byte & 0xff);
    const hex = bytes.map((byte) => byte.toString(16).padStart(2, "0").toUpperCase());
    const paddedHex = [...hex, ...Array(16 - hex.length).fill("  ")].join(" ");
    const ascii = bytes
      .map((byte) => (byte >= 32 && byte <= 126 ? String.fromCharCode(byte) : "·"))
      .join("");
    rows.push(`${offset.toString(16).padStart(8, "0").toUpperCase()}  ${paddedHex}  ${ascii}`);
  }

  return (
    <pre
      style={{
        margin: 0,
        overflow: "auto",
        fontFamily: "monospace",
        whiteSpace: "pre",
        ...style,
      }}
    >
      {rows.join("\n")}
    </pre>
  );
};

interface Props {
  detailedEvent: Event;
  settings: Settings;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    list: {},
    item: {},
  })
);

export const EventDetailsComponent: React.FunctionComponent<Props> = (
  props
) => {
  const { settings, detailedEvent } = props;
  const classes = useStyles();

  const [value, setValue] = React.useState("data");

  const handleChange = (event: React.ChangeEvent<{}>, newValue: string) => {
    setValue(newValue);
  };

  return (
    <>
      <AppBar position="static">
        <Tabs
          indicatorColor="secondary"
          textColor="inherit"
          value={value}
          onChange={handleChange}
        >
          <Tab label="Инфо" value="info" />
          <Tab label="Данные" value="data" />
          <Tab
            label="HEX"
            value="hex"
            disabled={detailedEvent.source == null}
          />
        </Tabs>
      </AppBar>

      <TabContext value={value}>
        <TabPanel value="info">
          <ul className={classes.list}>
            <li className={classes.item}>
              <b>Контроллер:</b> {detailedEvent.device_id}
            </li>
            <li className={classes.item}>
              <b>Время события:</b>{" "}
              <DateTime
                dateFormat={settings.dateFormat}
                timeFormat={settings.timeFormat}
                timeZone={settings.timeZone}
                dateTime={detailedEvent.event_at}
              />
            </li>
            <li className={classes.item}>
              <b>Время получения события:</b>{" "}
              <DateTime
                dateFormat={settings.dateFormat}
                timeFormat={settings.timeFormat}
                timeZone={settings.timeZone}
                dateTime={detailedEvent.created_at}
              />
            </li>
            <li className={classes.item}>
              <b>Будет удалено:</b>{" "}
              <DateTime
                dateFormat={settings.dateFormat}
                timeFormat={settings.timeFormat}
                timeZone={settings.timeZone}
                dateTime={detailedEvent.evicted_at}
              />
            </li>
            <li className={classes.item}>
              <b>Версия выхода: </b>
              {"0x" +
                (detailedEvent.out_version + 0x100000000)
                  .toString(16)
                  .substr(-8)
                  .toUpperCase() +
                " (" +
                detailedEvent.out_version +
                ")"}
            </li>
          </ul>
        </TabPanel>

        <TabPanel value="data">
          <ReactJson
            style={{
              padding: 10,
              border: "1px solid rgba(0, 0, 0, 0.12)",
              borderRadius: 3,
            }}
            // theme="monokai"
            src={detailedEvent.values}
            name={null}
            displayObjectSize={false}
            displayDataTypes={false}
            enableClipboard={false}
            sortKeys={true}
          />
        </TabPanel>

        <TabPanel value="hex">
          <HexViewer data={detailedEvent.source || []} style={{ height: 300 }} />
        </TabPanel>
      </TabContext>
    </>
  );
};
